import { TFolderModes } from '@widgets/Files/model/types/modalMode.type';

interface IFolderModalData {
    headerText: Partial<Record<TFolderModes, string>>;
}

export const folderModalData: IFolderModalData = {
    headerText: {
        // @ts-ignore
        folderEdit: i18next.t('Files.FolderModal.Edit.Header'),
        // @ts-ignore
        folderCreate: i18next.t('Files.FolderModal.Create.Header'),
    },
};
